export default class BrowserDetectHelper {
    public static getBrowserInfo()
    {
        const userAgent = navigator.userAgent;
        let browserName;

        if (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Edg") === -1 && userAgent.indexOf("OPR") === -1) {
            browserName = "Google Chrome";
        } else if (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1) {
            browserName = "Safari";
        } else if (userAgent.indexOf("Firefox") > -1) {
            browserName = "Firefox";
        } else if (userAgent.indexOf("Edg") > -1) {
            browserName = "Microsoft Edge";
        } else if (userAgent.indexOf("OPR") > -1 || userAgent.indexOf("Opera") > -1) {
            browserName = "Opera";
        } else if (userAgent.indexOf("MSIE") > -1) { // Detect IE
            browserName = "Internet Explorer";
        } else {
            browserName = "Unknown";
        }

        return browserName;
    }

    public static getOsInfo()
    {
        if ((navigator as any).userAgentData) {
            // Use User-Agent Client Hints (modern browsers)
            const platform = (navigator as any).platform || "Unknown";
            if(/win32/i.test(platform))
                return "Windows";
            return platform;
        } else {
            // Fallback to user agent string for older browsers
            const userAgent = window.navigator.userAgent;
            if (/Windows/i.test(userAgent)) {
                return "Windows";
            } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
                return "iOS";
            } else if (/Mac/i.test(userAgent)) {
                return "macOS";
            } else if (/Linux/i.test(userAgent)) {
                return "Linux";
            } else if (/Android/i.test(userAgent)) {
                return "Android";
            } else {
                return "Unknown";
            }
        }
    }
}